import { render, staticRenderFns } from "./ImgAd.vue?vue&type=template&id=23e4e3b3&scoped=true&"
import script from "./ImgAd.vue?vue&type=script&lang=js&"
export * from "./ImgAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e4e3b3",
  null
  
)

export default component.exports